export default "__VITE_PUBLIC_ASSET__a042e2c9__"